import script from "./Propertytypesection.vue?vue&type=script&setup=true&lang=js"
export * from "./Propertytypesection.vue?vue&type=script&setup=true&lang=js"

import "./Propertytypesection.vue?vue&type=style&index=0&id=f2ed7f8e&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2ed7f8e"]])

export default __exports__